export default __webpack_public_path__ + "static/media/canago.4b667b35.jpg";